export function resetMaterialUseAddForm() {
    console.log(this)

    this.$emit('mergeFormData', {
        material_id: '',
        cnt: 1,
        has_old: '',
        remark: ''
    })
}
